import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as actions from '../actions'
import { OperacionesFumigadoSiloDialogView } from '../components/OperacionesFumigadoSiloDialogView'

class OperacionesFumigadoSiloDialog extends Component {
  render () {
    const { silo } = this.props
    return (
      <OperacionesFumigadoSiloDialogView
        silo={silo}
        openDialogNuevoFumigado={this.props.openDialogNuevoFumigado}
        openDialogModificacionFumigado={this.props.openDialogModificacionFumigado}
        openDialogEliminarUltimoFumigado={this.props.openDialogEliminarUltimoFumigado}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    silo: state.movimientoSilos.siloOperando
  }
}
export default connect(mapStateToProps, actions)(OperacionesFumigadoSiloDialog)
